<script setup lang="ts">
// Gold's knob section for the shared FundBacktestPanel (option C,
// 2026-10-11) — moved verbatim out of GoldBacktestPanel.vue. Edits the
// panel's reactive `params` in place.
import type { BacktestParams } from '../../api/client'

defineProps<{ params: BacktestParams; bandError: string | null }>()
</script>

<template>
  <section class="params-section">
    <h3>Parameters</h3>
    <label class="checkbox-label">
      <input type="checkbox" v-model="params.postDatabentoOnly" data-testid="post-databento-checkbox" />
      Post-Databento window only
      <span class="knob-hint">clamps the run to intraday coverage (2010-06-14+); pre-coverage days fail-safe to hold and drag metrics</span>
    </label>
    <label>
      Yield collapse gate:
      <select v-model="params.yieldCollapseGateMode">
        <option value="off">off</option>
        <option value="on">on</option>
      </select>
    </label>
    <label v-if="params.yieldCollapseGateMode === 'on'">
      Drop threshold (bps): <input type="number" v-model.number="params.yieldCollapseDropBps" />
    </label>
    <label v-if="params.yieldCollapseGateMode === 'on'">
      Window (days): <input type="number" v-model.number="params.yieldCollapseWindowDays" />
    </label>
    <label>
      Decision driver:
      <select v-model="params.stepAsideMode">
        <option value="off">No futures rule</option>
        <option value="pure">Hold unless futures down</option>
        <option value="gate">Fund strategy, futures can force SELL</option>
      </select>
    </label>
    <template v-if="params.stepAsideMode !== 'off'">
      <label>Futures drop to trigger SELL (bps): <input type="number" v-model.number="params.stepAsideThresholdBps" data-testid="step-aside-threshold-input" /></label>
      <!-- 2026-09-15 dead-zone rule: empty = legacy one-sided, any number opts in (must be >= SELL). -->
      <label title="Empty = legacy one-sided rule. Any number opts in: prints in [SELL, BUY]bps hold current allocation. Must be >= SELL threshold.">Futures rise to trigger BUY (bps):
        <input type="number"
               placeholder="(none = one-sided)"
               :value="params.stepAsideBuyThresholdBps ?? ''"
               @input="e => { const v = (e.target as HTMLInputElement).value; params.stepAsideBuyThresholdBps = v === '' ? null : Number(v) }"
               data-testid="step-aside-buy-threshold-input" />
      </label>
      <div v-if="bandError" class="error-hint" data-testid="step-aside-band-error">{{ bandError }}</div>
      <!-- step_aside_reentry_bps retired 2026-09-02 (spec 2026-09-02-flicker-band-detector §5): engine ignores it; input removed. -->
    </template>
  </section>
</template>

<style scoped src="./fundBacktestKnobs.css"></style>
